module.exports = __webpack_public_path__ + "static/img/bannerNew2.7900017.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/bannerNew2.webp
// module id = zYcq
// module chunks = 1